import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

import map from "../../images/Toronto-Map-Black-Line-3-1024x637.jpg";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const TextInfo = tw.div`py-1 sm:px-10 sm:py-1`;

const Content = tw.div`mt-16`;

const imageCss = tw`rounded-4xl`;

const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
const Subheading = tw.span`tracking-wider text-sm font-medium`;

const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
  ];

  return (
    <Container>
      <TextInfo>Privacy Policy</TextInfo>
      <TextInfo>As of July 11, 2024.</TextInfo>
      <TextInfo>This policy states our privacy practices that are in place for all mobile services and platforms including without limitation mobile applications (hereinafter referred to as ''the Services'' or ''the applications'') that are provided by and operated under Water Limousine Charters Inc. Throughout the duration of this policy, the terms ''We'' and ''us'' refer to Water Limousine Charters Inc . The term ''you'' refers to you as the user of the Services.</TextInfo>

      <TextInfo>1. Information We Collect and How We Collect It</TextInfo>
      <TextInfo>1.1 Information We Collect</TextInfo>
      <TextInfo>We may collect data about water taxi trips and the boat you operate on, if you submit it to us. We may also collect your hardware device information.</TextInfo>

      <TextInfo>1.2 How We Collect Your Information</TextInfo>
      <TextInfo>1.2.1 Forms</TextInfo>
      <TextInfo>You can submit information about water taxi trips and your boat from the 'Trips' and 'My Boat' page.</TextInfo>


      <TextInfo>2. How We Use Your Data</TextInfo>
      <TextInfo>2.1 Device Information</TextInfo>
      <TextInfo>Your unique device identifier is used to allow you to sign in to the Service automatically without the need to verify your account through phone number verification.</TextInfo>

      <TextInfo>2.2 Trip Information</TextInfo>
      <TextInfo>We use the trip information you submit for adminstration statistical analysis.</TextInfo>

      <TextInfo>2.3 Boat Information</TextInfo>
      <TextInfo>We use the boat information you submit to us for boat maintenance.</TextInfo>

      <TextInfo>3. The Sharing of Your Data with Third Parties.</TextInfo>
      <TextInfo>We do not share your data with any third parties.</TextInfo>

      <TextInfo>4. Data Deletion/Retention</TextInfo>
      <TextInfo>4.1 Deletion of Your Account/Data</TextInfo>
      <TextInfo>Your account will remain active throughout the duration of your employment with us. However, if you have any serious concerns you can contact your manager to have your account deleted.</TextInfo>

      <TextInfo>4.2 Retention of Your Data</TextInfo>
      <TextInfo>Once your account is deleted, we may retain the trip information you submit to us for statistical analysis.</TextInfo>


      <TextInfo>Modifications to this Policy:</TextInfo>
      <TextInfo>In the event we make any modifications to the Privacy Policy, your use of the Services after we make modifications to the Privacy Policy means that you accept the modified Privacy Policy. If you disagree with this Policy, you cannot use the Services.</TextInfo>

      <TextInfo>Data Security Information:</TextInfo>
      <TextInfo>While we implement numerous security processes and measures to ensure the privacy and protection of your information and data, such as HTTPS, SSL, data encryption and Two-Factor Authentication for server sign-ons, we cannot guarantee the protection of your information and data when transmitting your information and data through the Internet.</TextInfo>

      <TextInfo>By using the Services, you hereby consent to this Privacy Policy. </TextInfo>
    </Container>
  );
};
